module.exports = __webpack_public_path__ + "img/mitsu-service.4936aca3.png";